$(document).ready(function (){
    if (window.location.hash){
        var $scrollToBlock = $(location.hash);
        if ($scrollToBlock.length){
            window.history.scrollRestoration = 'manual';
            setTimeout(function (){
                $("html, body").animate({ scrollTop: $scrollToBlock.offset().top - 140}, 700);
            },100);
        }
    }
    /* Account page change delivery date, frequency, address */
    $('.change-btn').on('click', function() {
        var rowId = $(this).attr('data-row-id');
        var $row = $('#'+rowId);
        $row.find('.hidden-content').slideDown(300);
        if ($(this).hasClass('change-btn-hide')) {
            $(this).css('opacity', '0').css('visibility', 'hidden');
            // $(this).hide();
            // $(this).prev().hide();
        }
        if ($(this).attr('data-row-id') == 'billing-attempts-row' || $(this).attr('data-row-id') == 'change-payment-method-row') {
            $(this).hide();
            $(this).next().show();
        }

        // if($(this).attr('data-row-id') == "next-payment-date-row" || $(this).attr('data-row-id') == "delivery-frequency-row"){
        //     $(this).parent().parent().find('.row_label').addClass('not-margin-bottom');
        // }

    });
    $('.cancel-change-btn').on('click', function() {
        $(this).closest('.order-info-item').find('.hidden-content').slideUp(300);
        $(this).closest('.order-info-item').find('.change-btn-hide').css('visibility', 'visible').css('opacity', '1');
        // $(this).closest('.hidden-content').hide(300);
        //$(this).closest('.subscription_info-row').find('.change-btn-hide').css('opacity', '1');
        // $(this).closest('.subscription_info-row').find('.change-btn-hide').show();
        // $(this).closest('.subscription_info-row').find('.change-btn-hide').prev().show();
        // if($(this).parent().parent().find('.not-margin-bottom')){
        //     $(this).parent().parent().find('.not-margin-bottom').removeClass('not-margin-bottom');
        // }
        if ($(this).attr('data-row-id') == 'billing-attempts-row' || $(this).attr('data-row-id') == 'change-payment-method-row') {
            // var rowId = $(this).attr('data-row-id');
            // var $row = $('#'+rowId);
            // $row.find('.hidden-content').slideUp(300);
            $(this).hide();
            $(this).prev().show();
        }
        // if ($(this).attr('data-row-id') == 'change-payment-method-row') {
        //     var rowId = $(this).attr('data-row-id');
        //     var $row = $('#'+rowId);
        //     $row.find('.hidden-content').slideUp(300);
        //     $(this).parent().hide();
        //     $(this).parent().prev().show();
        // }
    });

    $('#change-address-scroll-btn').on('click', function() {
        $("html, body").animate({ scrollTop: $('.account-addresses').offset().top - 100 }, 1000);
    });

    /* Cancel reasons radio buttons */
    $('.cancel-reason > input:checked').nextAll('.cancel-note').show().addClass('opened');
    $('.cancel-reason > input').on('change', function () {
        $('.opened, .sub-opened').slideUp(300);
        $(this).nextAll('.cancel-sub-reason').find('input:checked').nextAll('.cancel-note').show().addClass('sub-opened');
        $(this).nextAll('.cancel-sub-reason').slideDown(300).addClass('opened');
        $(this).nextAll('.cancel-note').slideDown(300).addClass('opened');
    });
    $('.cancel-sub-reason > input').on('change', function () {
        $('.sub-opened').slideUp(300);
        $(this).nextAll('.cancel-note').slideDown(300).addClass('sub-opened');
    });

    /* Account addresses page (edit popup) */
    $('.edit-address-btn').on('click', function () {
        var addressId = $(this).attr('data-address-id');
        $('#EditAddress_' + addressId).fadeIn(500);
        $('body').css('overflow', 'hidden');
        $('body').css('touch-action', 'none');
        $('body').css('-ms-touch-action', 'none');
    });

    /* Account subscription page - GA events */
    // $('#btn-skip-next-renewal-action').on('click', function() {
    //     ga('send', 'event', {
    //         eventCategory: 'Customer account page',
    //         eventAction: 'click',
    //         eventLabel: 'Skip next renewal'
    //     });
    // });
    //
    // $('#btn-action-renew-now').on('click', function() {
    //     ga('send', 'event', {
    //         eventCategory: 'Customer account page',
    //         eventAction: 'click',
    //         eventLabel: 'Renew now'
    //     });
    // });

    $('#payment-method-select li').on('click', function() {
        $('#payment-method-select li').removeClass('selected');
        $(this).addClass('selected');
        $(this).closest('.change-select-wrapper').find('#btn-subscription-select-payment-method-done').removeClass('disabled');
    });

    $('.account-info-link').on('click', function (){
        $(this).toggleClass('opened');
        $('.account-info-items').slideToggle(300);
    });
    $('.edit-account-info').on('click', function (e){
        var targetId = $(this).attr('data-edit');
        $('#'+targetId).fadeIn(300);
    });

    $('.account-nav-open').on('click', function (){
        $('.account-sidebar').addClass('opened');
        // $('body').addClass('account-nav-opened');
    });
    $('.account-nav-close').on('click', function (){
        $('.account-sidebar').removeClass('opened');
        // $('body').removeClass('account-nav-opened');
    });

    $('.related-orders .see-more-orders').on('click', function(){
        $(this).hide();
        $(this).closest('.related-orders').find('.orders-wrapper').slideDown(500);
        $(this).closest('.related-orders').find('.see-less-orders').show();
    });
    $('.related-orders .see-less-orders').on('click', function(){
        $(this).hide();
        $(this).closest('.related-orders').find('.orders-wrapper').slideUp(500);
        $(this).closest('.related-orders').find('.see-more-orders').show();
    });

    $('.section--orders .see-more-orders').on('click', function(){
        $(this).hide();
        $(this).closest('.section--orders').find('.hidden-order-card').slideDown(500);
        $(this).closest('.section--orders').find('.see-less-orders').show();
        $(this).closest('.section--orders').find('.pagination-wrapper').slideDown(500);
    });
    $('.section--orders .see-less-orders').on('click', function(){
        $(this).hide();
        $(this).closest('.section--orders').find('.hidden-order-card').slideUp(500);
        $(this).closest('.section--orders').find('.see-more-orders').show();
        $(this).closest('.section--orders').find('.pagination-wrapper').slideUp(500);
    });


    $('.edit-account-info-popup form').on('submit', function(e){
        e.preventDefault();
        $('#loading-overlay').fadeIn(500);
        var $form = $(this);
        var reqUrl = $form.attr('action');
        var dataKey = $form.find('.account-info-input').attr('name');
        var dataValue = $form.find('.account-info-input').val();
        var dataToSend = {};
        dataToSend[dataKey] = dataValue;
        $(this).find('.error').slideUp(200);
        $.ajax({
            type: 'POST',
            url: reqUrl,
            data: JSON.stringify(dataToSend),
            success: function (response) {
                if (response.success) {
                    $('.account-info').find('.item-value[data-name="'+dataKey+'"]').text(dataValue);
                    $('#loading-overlay').fadeOut(500);
                    $form.closest('.edit-account-info-popup').fadeOut(200);
                    if (dataKey === 'first_name'){
                        var firstName = $('.account-info').find('.item-value[data-name="first_name"]').first().text().trim();
                        if (firstName){
                            $('.hello-message .customer-name').text(firstName);
                        }
                    }
                } else {
                    $('#loading-overlay').fadeOut(500);
                    $form.find('.error').slideDown(200);
                }
            },
        })
    });
    $('.edit-account-info-popup form input').on('input', function(e){
        $(this).closest('form').find('.error').slideUp(200);
    });

    initStickyUpdateBtn();
    function initStickyUpdateBtn() {
        if (!$('.subscription-sticky-btn').length){
            return;
        }
        var $originalBtn = $('.subscription-sticky-btn');
        var $stickyBtn = $originalBtn.clone(true);
        var $stickyBar = $('<div class="sticky-update-bar"></div>');
        $stickyBtn.appendTo($stickyBar);
        $stickyBar.appendTo($('body'));
        var options = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        };
        var callback = function (entries, observer) {
            if (entries[0].isIntersecting) {
                $stickyBar.removeClass('is-visible');
            }
            else {
                $stickyBar.addClass('is-visible');
            }
        };
        var observer = new IntersectionObserver(callback, options);
        observer.observe($originalBtn[0]);
    }
});